import { Form, Row } from 'antd';
import React, { useState } from 'react';

import ButtonComponent from 'components/atoms/ButtonComponent';
import InputComponent from 'components/atoms/InputComponent';
import Paragraph from 'components/atoms/Paragraph';
import SelectComponent from 'components/atoms/SelectComponent';
import Title from 'components/atoms/Title';
import LoadingWrapper from 'components/hoc/LoadingWrapper';
import FormWrapper from 'components/molecules/FormWrapper';
import FsluzbyIdentifikace from 'components/molecules/StatniSprava/Identifikace';

import { useFormBasics } from 'hooks/statniSprava/useFormBasics';
import usePageName from 'hooks/usePageName';

import typOsobySelect from 'data/codebooks/specialniSluzby/typOsobySelect';

import AlertComponent from './AlertComponent';
import OdeslaniPozadavkuRows from './odeslaniPozadavkuRows';

interface IF30 {}

const F30: React.FC<IF30> = () => {
    const [form] = Form.useForm();
    const pageName = usePageName();
    const [, rerender] = useState<boolean>(false);
    const [
        errMsg,
        currentStep,
        idSluzby,
        upozorneni,
        loading,
        odeslaniResp,
        setErrMsg,
        prev,
        onFormSubmit,
        showPxKlicLoadingMsg
    ] = useFormBasics();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const onFinish = (fieldsValue: any) => {
        const dataToSend = {
            ...fieldsValue,
            ...(fieldsValue.idmb &&
                typeof fieldsValue.idmb === 'object' && {
                    idmb: fieldsValue.idmb.format('YYYYMMDD')
                })
        };
        onFormSubmit(dataToSend);
    };

    return (
        <LoadingWrapper loading={loading} loadingText={showPxKlicLoadingMsg ? 'LOADING_PXKLIC' : 'NACITANI'}>
            <Title level={4} text="DUVERNE_INFO_TITLE_F30" />
            {errMsg ? (
                <>
                    <Paragraph text={errMsg} />
                    <Row>
                        <ButtonComponent
                            id="f30ZpetBtn"
                            type="default"
                            buttontext="ZPET"
                            onClick={() => setErrMsg('')}
                        />
                    </Row>
                </>
            ) : (
                <>
                    {currentStep !== 2 ? (
                        <FormWrapper onFinish={onFinish} outForm={form}>
                            <>
                                {pageName === 'page197' ? (
                                    <>
                                        <InputComponent
                                            disabled={currentStep > 0}
                                            label="ME_POZADAVKY_INDENTIFIKACE_SOUDU"
                                            name="idco"
                                            maxLength={100}
                                        />
                                        <InputComponent
                                            disabled={currentStep > 0}
                                            label="SPISOVA_ZNACKA"
                                            name="actn"
                                            maxLength={30}
                                        />
                                        <FsluzbyIdentifikace
                                            form={form}
                                            disabled={currentStep > 0}
                                            rerender={rerender}
                                        />
                                    </>
                                ) : (
                                    <>
                                        <InputComponent
                                            disabled={currentStep > 0}
                                            label="ME_POZADAVKY_CISLO_JEDNACI"
                                            name="actn"
                                            maxLength={30}
                                        />
                                        <SelectComponent
                                            name="octg"
                                            labelParagraph="ME_POZADAVKY_KATEGORIE_MAJITELE"
                                            labelCol={{
                                                span: 8
                                            }}
                                            data={typOsobySelect}
                                            onChange={() => {
                                                form.setFieldsValue({
                                                    identifikace: undefined
                                                });
                                                rerender(pv => !pv);
                                            }}
                                            isFormItem={true}
                                            disabled={currentStep > 0}
                                            defaultValue={typOsobySelect[0].value}
                                        />
                                        <FsluzbyIdentifikace
                                            form={form}
                                            disabled={currentStep > 0}
                                            rerender={rerender}
                                        />
                                    </>
                                )}
                                {/* <InputComponent
                                    label={'ME_POZADAVKY_PRIJMENO'}
                                    name="pjma"
                                    type="text"
                                    maxLength={250}
                                    notRequired={true}
                                    hide={currentStep === 1 && !form.getFieldValue('pjma')}
                                    disabled={currentStep > 0}
                                />
                                <InputComponent
                                    label={'ME_POZADAVKY_JMENO'}
                                    name="jmma"
                                    type="text"
                                    maxLength={250}
                                    notRequired={true}
                                    hide={currentStep === 1 && !form.getFieldValue('jmma')}
                                    disabled={currentStep > 0}
                                />*/}
                                {currentStep === 0 && (
                                    <ButtonComponent
                                        id="f30OdeslatBtn"
                                        buttontext="ODESLAT"
                                        onClick={() => form.submit()}
                                    />
                                )}
                                {currentStep !== 0 && upozorneni && (
                                    <AlertComponent
                                        upozorneni={upozorneni}
                                        type={currentStep === 1 ? 'error' : 'info'}
                                    />
                                )}
                                {currentStep === 1 && (
                                    <Row className="button-row">
                                        <ButtonComponent
                                            id="f30ZpetAltBtn"
                                            buttontext="ZPET"
                                            onClick={() => prev()}
                                            type="default"
                                        />

                                        <ButtonComponent
                                            id="f30PotvrditBtn"
                                            buttontext="POTVRDIT"
                                            onClick={() => form.submit()}
                                        />
                                    </Row>
                                )}
                            </>
                        </FormWrapper>
                    ) : (
                        <>
                            <OdeslaniPozadavkuRows idSluzby={idSluzby} datum={odeslaniResp?.datum} />
                            {upozorneni && <AlertComponent upozorneni={upozorneni} type={'info'} />}
                        </>
                    )}
                </>
            )}
        </LoadingWrapper>
    );
};

export default F30;
